import { WppSkeleton } from '@wppopen/components-library-react'
import AsyncTypography from 'components/AsyncTypography/AsyncTypography'
import styles from './PageHeaderStatusRow.module.scss'
import { Fragment } from 'react'

interface PageHeaderStatusRowProps {
  isLoading?: boolean
  tags: (JSX.Element | undefined | false)[]
  text: string
}

const PageHeaderStatusRow = ({ isLoading, tags, text }: PageHeaderStatusRowProps) => {
  return (
    <div className={styles.headerStatusRow}>
      <div className={styles.tagsContainer}>
        {isLoading ? (
          <WppSkeleton data-testid="loading-skeleton" width={100} height={24} />
        ) : (
          tags.map((tag, index) => <Fragment key={index}>{tag}</Fragment>)
        )}
      </div>

      <AsyncTypography
        isLoading={isLoading}
        type="s-body"
        tag="p"
        width={300}
        dataTestId="created-date-or-approved-date"
      >
        {text}
      </AsyncTypography>
    </div>
  )
}

export default PageHeaderStatusRow
